
import { useEffect } from 'react';
import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';
import { useSEO } from '../../utils/seo';

export default function ConditionsUtilisation() {
  useSEO({
    title: 'Conditions d\'utilisation — OTOROBOTS CANADA INC.',
    description: 'Conditions d\'utilisation du site web d\'OTOROBOTS CANADA INC. : règles d\'utilisation, propriété intellectuelle, limitation de responsabilité et dispositions légales.',
    keywords: 'conditions d\'utilisation, règles, propriété intellectuelle, OTOROBOTS, Canada',
    canonical: '/conditions-utilisation',
    ogTitle: 'Conditions d\'utilisation — OTOROBOTS CANADA INC.',
    ogDescription: 'Conditions d\'utilisation du site web d\'OTOROBOTS CANADA INC. : règles d\'utilisation et dispositions légales.',
    schema: {
      '@type': 'WebPage',
      name: 'Conditions d\'utilisation',
      description: 'Conditions d\'utilisation du site web d\'OTOROBOTS CANADA INC.',
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      <main className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <header>
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-8">
              Conditions d'utilisation
            </h1>
          </header>

          <article className="space-y-8 text-gray-700 leading-relaxed">
            <section>
              <p className="text-lg mb-4">
                En accédant et en utilisant le site web d'OTOROBOTS CANADA INC., vous acceptez de vous conformer 
                aux présentes conditions d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas 
                utiliser ce site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Nature du site
              </h2>
              <p className="mb-3">
                Le site web d'OTOROBOTS CANADA INC. est un site informatif et institutionnel. Il a pour objectif 
                de présenter l'entreprise, sa mission, sa vision, ses valeurs et ses activités.
              </p>
              <p>
                <strong>Important :</strong> Ce site ne propose aucune vente directe de produits ou services. 
                Il ne constitue pas une plateforme de commerce électronique. Aucune transaction commerciale 
                n'est effectuée directement sur ce site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Utilisation du site
              </h2>
              <p className="mb-3">
                Vous vous engagez à utiliser ce site de manière responsable et conforme aux lois applicables. 
                Il est notamment interdit de :
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Utiliser le site à des fins illégales ou non autorisées</li>
                <li>Tenter d'accéder de manière non autorisée aux systèmes ou réseaux du site</li>
                <li>Transmettre des virus, logiciels malveillants ou tout code nuisible</li>
                <li>Collecter des informations sur d'autres utilisateurs sans leur consentement</li>
                <li>Perturber le fonctionnement normal du site</li>
                <li>Reproduire, copier ou exploiter le contenu du site sans autorisation</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Propriété intellectuelle
              </h2>
              <p className="mb-3">
                Tous les éléments du site (textes, images, logos, graphismes, vidéos, structure, design) 
                sont la propriété exclusive d'OTOROBOTS CANADA INC. ou de ses partenaires, et sont protégés 
                par les lois sur la propriété intellectuelle.
              </p>
              <p className="mb-3">
                Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie 
                des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans 
                l'autorisation écrite préalable d'OTOROBOTS CANADA INC.
              </p>
              <p>
                L'utilisation non autorisée du contenu peut constituer une violation des lois sur le droit d'auteur, 
                les marques de commerce et d'autres lois applicables.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Limitation de responsabilité
              </h2>
              <p className="mb-3">
                OTOROBOTS CANADA INC. s'efforce de maintenir l'exactitude et l'actualité des informations 
                présentées sur ce site. Toutefois, l'entreprise ne peut garantir que les informations soient 
                toujours complètes, exactes ou à jour.
              </p>
              <p className="mb-3">
                L'entreprise décline toute responsabilité pour :
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Les erreurs ou omissions dans le contenu du site</li>
                <li>Les dommages directs ou indirects résultant de l'utilisation du site</li>
                <li>L'interruption, la suspension ou l'indisponibilité du site</li>
                <li>Les virus ou autres éléments nuisibles pouvant affecter votre équipement</li>
                <li>Le contenu des sites externes vers lesquels ce site pourrait renvoyer</li>
              </ul>
              <p className="mt-3">
                L'utilisation de ce site se fait à vos propres risques, dans les limites permises par la loi applicable.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Disponibilité du site
              </h2>
              <p>
                OTOROBOTS CANADA INC. se réserve le droit de modifier, suspendre ou interrompre tout ou partie 
                du site à tout moment, sans préavis et sans engager sa responsabilité. L'entreprise ne garantit 
                pas que le site sera disponible en permanence ou exempt d'erreurs.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Liens externes
              </h2>
              <p>
                Ce site peut contenir des liens vers des sites web externes. Ces liens sont fournis uniquement 
                pour votre commodité. OTOROBOTS CANADA INC. n'exerce aucun contrôle sur ces sites et n'est pas 
                responsable de leur contenu, de leur disponibilité ou de leurs pratiques en matière de confidentialité.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Données personnelles
              </h2>
              <p>
                La collecte et l'utilisation de vos données personnelles sont régies par notre 
                <a href="/politique-confidentialite" className="text-teal-600 hover:text-teal-700 font-medium mx-1">
                  Politique de confidentialité
                </a>
                que nous vous invitons à consulter.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Modifications des conditions
              </h2>
              <p>
                OTOROBOTS CANADA INC. se réserve le droit de modifier les présentes conditions d'utilisation 
                à tout moment. Les modifications entrent en vigueur dès leur publication sur cette page. 
                Votre utilisation continue du site après la publication de modifications constitue votre 
                acceptation de ces modifications.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Acceptation des conditions
              </h2>
              <p>
                L'accès et l'utilisation de ce site impliquent l'acceptation pleine et entière des présentes 
                conditions d'utilisation. Si vous n'acceptez pas ces conditions, vous devez cesser immédiatement 
                d'utiliser le site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Loi applicable et juridiction
              </h2>
              <p>
                Les présentes conditions d'utilisation sont régies et interprétées conformément aux lois 
                en vigueur au Canada. Tout litige relatif à l'utilisation de ce site sera soumis à la 
                compétence exclusive des tribunaux canadiens.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Divisibilité
              </h2>
              <p>
                Si une disposition des présentes conditions est jugée invalide ou inapplicable par un tribunal 
                compétent, les autres dispositions demeureront en vigueur et de plein effet.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Contact
              </h2>
              <p>
                Pour toute question concernant ces conditions d'utilisation, vous pouvez nous contacter à :
              </p>
              <p className="mt-2">
                <a href="mailto:info@otorobots.com" className="text-teal-600 hover:text-teal-700 font-medium">
                  info@otorobots.com
                </a>
              </p>
            </section>

            <section className="pt-4 border-t border-gray-200">
              <p className="text-sm text-gray-600">
                Dernière mise à jour : Janvier 2026
              </p>
            </section>
          </article>
        </div>
      </main>

      <Footer />
    </div>
  );
}
